import classNames from 'classnames'
import getTitle from 'helpers/getTitle'
import useTranslate from 'modules/local/useTranslate'
import React from 'react'
import {BsInfoCircleFill} from 'react-icons/bs'
import {HeaderWithIconLine} from '../../Templates/items/ListHeader'
import {TbListSearch} from "react-icons/tb";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {Link} from "react-router-dom";
import {GoDotFill} from "react-icons/go";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {ItemInformation} from "../../../../components/common/ItemInformation";

const GRADE_FIELD_LABELS = {
    title: 'title of grade',
    description: 'description',
    status: 'status',
    active: 'active',
    score_weight: 'score weight',
    score_type: 'score type',
    score_options: 'score options',
    grade_date: 'grade date',
    // GradeDetail (điểm riêng của từng học viên)
    score_text: 'score',
    score_number: 'score',
    score_1_text: 'score 1',
    score_1_number: 'score 1',
    grade_1_date: 'grade date 1',
    score_2_text: 'score 2',
    score_2_number: 'score 2',
    grade_2_date: 'grade date 2',
}

export const CourseClassGradeHistory = ({item, grade}) => {

    const t = useTranslate()
    const {logs = [], grade_date, score_type, score_weight, subject} = grade ?? {}

    return (
        <div className="flex flex-col gap-6 p-3">
            <div className="px-3 py-2 border border-color-50 shadow-md rounded-xl w-full flex flex-col">
                <span className="font-semibold text-slate-700 tracking-wider">
                    {t('grade information')}
                </span>
                <div style={{height: 3}} className="mt-0.5 mb-2 w-20 rounded-full bg-gray-400"/>
                <div className="flex flex-col gap-1">
                    <ItemInformation primary={true} showIcon={true} label="title of grade" value={getTitle(grade)}
                                     className="text-xs tracking-wider"/>
                    <ItemInformation showIcon={true} label="subjects" value={getTitle(subject)} className="text-xs"/>
                    <ItemInformation showIcon={true} label="grade date" value={formatDate(grade_date, 'DD/MM/YYYY')}
                                     className="text-xs tracking-wider"/>
                    <ItemInformation showIcon={true} label="score type" value={t(score_type)}
                                     className="text-xs tracking-wider"/>
                    <ItemInformation showIcon={true} label="score weight" value={`x${score_weight}`}
                                     className="text-xs tracking-wider"/>
                </div>
            </div>
            <div className="flex flex-col gap-3">
                <HeaderWithIconLine
                    title="edit history"
                    className="text-sm text-color-300"
                />
                <div className="flex flex-col gap-3">
                    {logs.map((e, i) => {
                        const {user, action, text, created} = e ?? {}
                        let _label, _color;
                        const renderAction = (_action) => {
                            switch (_action) {
                                case 'create':
                                    _label = t('create')
                                    _color = 'text-green-600'
                                    break;
                                case 'update':
                                    _label = t('update')
                                    _color = 'text-blue-600'
                                    break;
                                case 'delete':
                                    _label = t('delete')
                                    _color = 'text-primary-500'
                                    break;
                                default:
                                    break;
                            }
                            return (
                                <span className={classNames('text-xs italic', _color)}>{t(_label)}</span>
                            )
                        }
                        const renderTime = () => (
                            <span className="text-xs text-color-500 italic leading-tight tracking-wide">
                                <GoDotFill size={10} className="mr-1 text-color-400"/>
                                {`${t('at_time')} : `}
                                <span className="text-color-300">
                                    {`
                                        ${formatDate(created, 'HH:mm')} - 
                                        ${formatDate(created, 'dddd')}, 
                                        ${formatDate(created, 'DD/MM/YYYY')}
                                    `}
                                </span>
                            </span>
                        )

                        return (
                            <div key={i} className="p-2 border border-color-50 rounded-lg flex items-start gap-2">
                                <span className="text-sm text-slate-500">
                                    {`${i + 1}. `}
                                </span>
                                <div className="flex flex-col gap-1">
                                    <span className="space-x-2 text-sm tracking-wide">
                                        <Link to={getLinkToDetail(e)} className="font-bold text-color-000 no-underline">
                                            {getTitle(user)}
                                        </Link>
                                        <span className="text-xs text-color-500 italic lowercase">
                                            {t('the action has been performed')}
                                        </span>
                                        <span className="text-xs italic">
                                            {renderAction(action)}
                                        </span>
                                    </span>
                                    {text && (
                                        <ItemInformation
                                            showIcon={true} label="content"
                                            value={
                                                <div className="flex flex-col pl-6">
                                                    {(text || '').split("|").map((e1, i1) => {
                                                        return (
                                                            <div key={i1}>
                                                                {
                                                                    (e1 || '').replace(
                                                                        /(\w+):(?:\s*(.*?)\s*)?->\s*(.+)/g,
                                                                        (match, field, oldValue, newValue) => {
                                                                            const fieldLabel = t(GRADE_FIELD_LABELS[field] || field)
                                                                            const isEmptyOld = !oldValue || oldValue === "(EMPTY)"
                                                                            if (isEmptyOld) {
                                                                                return `[${fieldLabel}]: [${newValue}]`;
                                                                            }
                                                                            return `[${fieldLabel}]: [${oldValue}] → [${newValue}]`;
                                                                        }
                                                                    )
                                                                }
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            }
                                            className="text-xs italic"
                                        />
                                    )}
                                    {renderTime()}
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}


export const CourseClassGradeDetailHistory = ({gradeDetail}) => {

    const t = useTranslate()
    const {logs = []} = gradeDetail ?? {}

    return (
        <div className="flex flex-col gap-3">
            <div>
                <div className="p-2 flex flex-center background-200 rounded-lg">
                    <TbListSearch size={15} className="text-color-500"/>
                </div>
                <div className="flex flex-col">
                    <span className="font-semibold text-lg text-slate-700 tracking-wider">
                        {t('edit history')}
                    </span>
                    <div className="mt-0.5 mb-2 w-20 h-1 rounded-full bg-gray-400"/>
                </div>
            </div>
            <div className="flex flex-col gap-3">
                {logs.map((e, i) => {
                    const {user, action, text, created} = e ?? {}
                    let _label, _color;
                    const renderAction = (_action) => {
                        switch (_action) {
                            case 'create':
                                _label = t('create')
                                _color = 'text-green-600'
                                break;
                            case 'update':
                                _label = t('update')
                                _color = 'text-blue-600'
                                break;
                            case 'delete':
                                _label = t('delete')
                                _color = 'text-primary-500'
                                break;
                            default:
                                break;
                        }
                        return (
                            <span className={classNames('text-xs italic', _color)}>{t(_label)}</span>
                        )
                    }

                    const renderTime = () => (
                        <span className="text-xs text-color-500 italic leading-tight tracking-wide">
                            <GoDotFill size={10} className="mr-1 text-color-400"/>
                            {`${t('at_time')} : `}
                            <span className="text-color-300">
                                {`
                                    ${formatDate(created, 'HH:mm')} - 
                                    ${formatDate(created, 'dddd')}, 
                                    ${formatDate(created, 'DD/MM/YYYY')}
                                `}
                            </span>
                        </span>
                    )
                    return (
                        <div key={i} className="p-2 border border-color-50 rounded-lg flex items-start gap-2">
                            <span style={{fontSize: 13}} className="text-color-500 leading-snug">
                                {`${i + 1}. `}
                            </span>
                            <div className="flex flex-col gap-1">
                                <span style={{fontSize: 13}} className="space-x-2 tracking-wide">
                                    <Link to={getLinkToDetail(e)} className="font-bold text-color-000 no-underline">
                                        {getTitle(user)}
                                    </Link>
                                    <span className="text-xs text-color-500 italic lowercase">
                                        {t('the action has been performed')}
                                    </span>
                                    <span className="text-xs italic">
                                        {renderAction(action)}
                                    </span>
                                </span>
                                {text && (
                                    <ItemInformation
                                        showIcon={true} label="content"
                                        value={
                                            <div className="flex flex-col pl-6">
                                                {(text || '').split("|").map((e1, i1) => {
                                                    return (
                                                        <div key={i1}>
                                                            {(e1 || '').replace(
                                                                /(\w+):(?:\s*(.*?)\s*)?->\s*(.+)/g,
                                                                (match, field, oldValue, newValue) => {
                                                                    const fieldLabel = t(GRADE_FIELD_LABELS[field] || field)
                                                                    const isEmptyOld = !oldValue || oldValue === "(EMPTY)"
                                                                    if (isEmptyOld) {
                                                                        return `[${fieldLabel}]: [${newValue}]`;
                                                                    }
                                                                    return `[${fieldLabel}]: [${oldValue}] → [${newValue}]`;
                                                                }
                                                            )}
                                                        </div>
                                                    )
                                                })}
                                            </div>
                                        }
                                        className="text-xs italic"
                                    />
                                )}
                                {renderTime()}
                            </div>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}
